import { QueryKey } from 'constants/reactQuery';

export const npsQueryKey = {
  npsCampaign: [QueryKey.DataAnalysis, 'npsCampaign'] as const,
  npsCampaignAnswer: (npsCampaignId?: number) => [...npsQueryKey.npsCampaign, npsCampaignId] as const,
};
